import React from 'react';

import './styles.scss';


const InputProfile = ({label,name,type,options,id,className= ""}) => {


    return (
        <div className={`InputProfile-Div ${className}`} >

            <label>{label}</label>
{ 
    type === 'select' ?
    <select className='InputProfile-Div-select'>
        <option value="" disabled hidden selected>Seleccione</option>
        {
            options.map((item, index) => {
                return(
                    <option key={index} value={item.value}>{item.name}</option>
                )



        })}

    </select>
    :    
    <input
        name={name}
        type= {type}
        id= {id}
    />    
    

}
        
        </div>
        
    )



}

export default InputProfile;